module.exports = __webpack_public_path__ + "exr-wrap.js.mem";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader/dist/cjs.js?name=exr-wrap.js.mem!./build_npm/exr-wrap/exr-wrap.js.mem
// module id = 2
// module chunks = 0